import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {FileModel} from 'src/app/shared/shared.model';

@Component({
  standalone: false,
  selector: 'app-file-view',
  templateUrl: './file-view.component.html',
  styleUrls: ['./file-view.component.scss']
})
export class FileViewComponent {
  constructor(
    public dialogRef: MatDialogRef<FileViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FileModel) { }

  onClose() {
    this.dialogRef.close();
  }
}
